import React from 'react';
import { Button } from 'grommet';
import { withRouter } from 'react-router-dom';
import { withFirebaseConsumer } from 'components/common/Firebase';
import * as ROUTES from 'components/common/Routes';

const GoogleSignInButton = props => {
  const signInWithGoogle = async () => {
    try {
      await props.firebase.doSignInWithGoogle();
      await props.history.push(ROUTES.LANDING);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Button
      color="status-error"
      label="with Google"
      margin="small"
      primary={true}
      onClick={signInWithGoogle}
    />
  );
};

export default withFirebaseConsumer(withRouter(GoogleSignInButton));
